import script from "./DHistogram.vue?vue&type=script&lang=js"
export * from "./DHistogram.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__